import { ListingReviewCardWrapper } from "./ListingReviewCardWrapper";
import { ListingReviewCardHeader } from "./ListingReviewCardHeader";
import { ListingReviewCardProfileImage } from "./ListingReviewCardProfileImage";
import { ListingReviewCardHeaderContent } from "./ListingReviewCardHeaderContent";
import { ListingReviewCardUsername } from "./ListingReviewCardUsername";
import { ListingReviewCardOrganisation } from "./ListingReviewCardOrganisation";
import { ListingReviewScore } from "./ListingReviewScore";
import { ListingReviewDescription } from "./ListingReviewDescription";

export const ListingReviewCard = () => {
  return (
    <ListingReviewCardWrapper>
      <ListingReviewCardHeader>
        <ListingReviewCardProfileImage />
        <ListingReviewCardHeaderContent>
          <ListingReviewCardUsername />
          <ListingReviewCardOrganisation />
          <ListingReviewScore />
        </ListingReviewCardHeaderContent>
      </ListingReviewCardHeader>

      <ListingReviewDescription />
    </ListingReviewCardWrapper>
  );
};
